import { Link } from "react-router-dom";
import { Card, CardBody, Col, Modal } from "reactstrap";
import { H5, Image, LI, UL } from "../../../../../AbstractElements";
import { BrooklynSimmons } from "../../../../../Constants/Constants";
import { DemoModalData } from "../../../../../Data/UiKits/Modal";
import { CustomModalBodyType } from "../../../../../Types/UiKitsType";
import { dynamicImage } from "../../../../../Utils";
import SvgIcon from "../../../../CommonComponents/SvgIcon/SvgIcon";

const CustomModal1Body:React.FC<CustomModalBodyType> = ({ modal, toggle }) => {
  return (
    <Modal fade centered isOpen={modal} toggle={toggle}>
      <Col xl="12">
        <Card className="social-profile mb-0 rounded-0">
          <CardBody>
            <div className="social-img-wrap">
              <div className="social-img">
                <Image src={dynamicImage(`product-lists/profile.png`)} alt="profile" />
              </div>
              <div className="edit-icon">
                <SvgIcon iconId="profile-check" />
              </div>
            </div>
            <div className="social-details">
              <H5 className="mb-1 f-w-600">
                <Link to={`${process.env.PUBLIC_URL}/applications/social-app`}>{BrooklynSimmons}</Link>
              </H5>
              <span className="f-light">{"@brookly.simmons"}</span>
              <UL className="social-follow simple-list flex-row">
                {DemoModalData &&
                  DemoModalData.map((item, index) => (
                    <LI key={index}>
                      <H5 className="mb-0">{item.class}</H5>
                      <span className="f-light">{item.text}</span>
                    </LI>
                  ))}
              </UL>
            </div>
          </CardBody>
        </Card>
      </Col>
    </Modal>
  );
};
export default CustomModal1Body;
